import React from 'react';
import { Auto } from 'fw/forms';
import * as API from 'modules/app/API'

class NaicsCodeCategoryAuto extends React.Component {

	NAICSCodeLoader = () => {
		return {
			url: API.App.url('/lookup/lookupNAICSCodeCategory'),
			params: {
				value: this.props.value
			}
		}
	}

	render() {
		return (
			<Auto
				{...this.props}
				menuWidth="400px"
				loader={this.NAICSCodeLoader}
				placeholder={this.props.placeholder} 
				maxLength={this.props.maxLength}
				/>
		)
	}
}

export default NaicsCodeCategoryAuto;

// Mark this as a form component
NaicsCodeCategoryAuto.defaultProps = {
	formControl: true,
	managed: false,
	placeholder: "Search..."
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/naicsCodeCategoryAuto/NaicsCodeCategoryAuto.js